<kendo-dialog minWidth="450" (close)="onCancel()">
  <kendo-dialog-titlebar>
    {{
      isNew()
        ? ('HOME_COMPONENTS.VIEW_SAVE.CREATE_VIEW' | translate)
        : ('HOME_COMPONENTS.VIEW_SAVE.SAVE_VIEW' | translate)
    }}
  </kendo-dialog-titlebar>
  <form novalidate class="k-form" [formGroup]="editForm">
    <div class="p-3" style="width: 450px">
      <kendo-formfield>
        <kendo-label [for]="viewConfigTitle" [text]="'HOME_COMPONENTS.VIEW_SAVE.NAME' | translate"></kendo-label>
        <input
          formControlName="viewConfigTitle"
          kendoTextBox
          #viewConfigTitle
          required
        />
        <kendo-formerror>{{ 'HOME_COMPONENTS.VIEW_SAVE.ERROR_NAME_REQUIRED' | translate }}</kendo-formerror>
      </kendo-formfield>
      <kendo-formfield class="mt-2">
        <div class="k-inline-checkbox">
          <input
            formControlName="keepFilters"
            kendoCheckBox
            #keepFilters
            type="checkbox"
          />
          <kendo-label
            [for]="keepFilters"
            class="k-checkbox-label"
            [text]="'HOME_COMPONENTS.VIEW_SAVE.SAVE_FILTERS' | translate"
          >
          </kendo-label>
        </div>
      </kendo-formfield>
    </div>
  </form>

  <kendo-dialog-actions [layout]="'end'">
    <button kendoButton look="outline" [size]="'small'" (click)="onCancel()">
      {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
    </button>
    <button
      kendoButton
      [themeColor]="'primary'"
      [disabled]="!editForm.valid"
      (click)="onSave()"
      [disabled]="!editForm.valid"
      [size]="'small'"
    >
      {{
        isNew()
          ? ('HOME_COMPONENTS.COMMON.CREATE' | translate)
          : ('HOME_COMPONENTS.COMMON.SAVE' | translate)
      }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
